import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { RichUtils } from 'draft-js';
import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
	margin: 0 0 40px 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Button = styled.button`
	width: ${props => props.inline ? '40px' : '100%'};
	padding: ${props => props.inline ? '8px 0 4px' : '8px 0 6px'};;
	background-color: white;
	border: 2px solid ${props => props.active ? '#4A90E2' : 'rgb(51, 51, 51, 0.2)'};
	-webkit-appearance: none;
	appearance: none;
	border-radius: 4px;
	font-size: 14px;
	cursor: pointer;
	margin-bottom: 4px;
	margin-right: ${props => props.inline ? '4px' : '0px'};
	color: ${props => props.active ? 'rgb(77, 77, 77)' : 'black'};

	svg {
		fill: ${props => props.active ? '#4A90E2' : 'rgb(230,230,230)'};
	}

	&:hover {
		border: 2px solid #4A90E2;
		color: #4A90E2;

		svg {
			fill: #4A90E2;
		}
	}
`;

const blockControls = [
	{
		action: 'header-one',
		name: 'controls/text/format/h1',
		style: {
			fontFamily: 'FSEmeric',
			color: 'rgb(77, 77, 77)',
			fontSize: '38pt'
		}
	},
	{
		action: 'header-two',
		name: 'controls/text/format/h2',
		style: {
			fontFamily: 'FSEmeric',
			color: 'rgb(77, 77, 77)',
			fontSize: '26pt',
			fontWeight: 'bold',
		}
	},
	{
		action: 'header-three',
		name: 'controls/text/format/h3',
		style: {
			fontFamily: 'FSEmeric',
			color: 'rgb(77, 77, 77)',
			fontSize: '16pt'
		}
	},
	{
		action: 'header-four',
		name: 'controls/text/format/h4',
		style: {
			fontFamily: 'FSEmeric',
			color: 'rgb(77, 77, 77)',
			fontSize: '9pt'
		}
	},
	{
		action: 'unstyled',
		name: 'controls/text/format/body',
		style: {
			fontFamily: 'CaeciliaLT',
			color: 'rgb(77, 77, 77)',
			fontSize: '9pt'
		}
	},
];
const BoldIcon = <Icon className="icon" icon="format-bold" />;
const ItalicIcon = <Icon className="icon" icon="format-italic" />;
const inlineControls = [
	{ action: 'BOLD', icon: BoldIcon, title: 'controls/text/format/bold' },
	{ action: 'ITALIC', icon: ItalicIcon, title: 'controls/text/format/italic' },
];
const TextControls = props => {
	const { t, lng, editorState: editorStates } = props;
	const editorState = editorStates[lng];
	let showInlineControls = false;

	if (typeof editorState !== 'undefined' && editorState) {
		var selectionState = editorState.getSelection();
		var anchorKey = selectionState.getAnchorKey();
		var currentContent = editorState.getCurrentContent();
		var currentContentBlock = currentContent.getBlockForKey(anchorKey);
		var start = selectionState.getStartOffset();
		var end = selectionState.getEndOffset();
		var selectedText = currentContentBlock.getText().slice(start, end);

		showInlineControls = selectedText !== '';
	}

	const inlineControlElements = inlineControls.map(control => {
		let active = false;

		if (typeof editorState !== 'undefined' && editorState) {
			const currentStyle = editorState.getCurrentInlineStyle();

			active = currentStyle.has(control.action);
		}
		return (
			<Button
				key={control.action}
				inline={true}
				active={active}
				title={t(control.title)}
				onClick={() => {
					switch (control.action) {
					case 'remove-styling':
						props.updateEditorState(RichUtils.tryToRemoveBlockStyle(editorState));
						break;
					default:
						props.updateEditorState(RichUtils.toggleInlineStyle(editorState, control.action));
						break;
					}
				}}
			>
				{control.icon}
			</Button>
		)
	});

	return (
		<Container>
			<Label>{t('controls/text/format/block/label')}</Label>
			{blockControls.map(control => {
				let active = false;

				if (typeof editorState !== 'undefined' && editorState) {
					const selection = editorState.getSelection();
					const blockType = editorState
						.getCurrentContent()
						.getBlockForKey(selection.getStartKey())
						.getType();
					active = control.action === blockType;
				}
				return (
					<Button
						key={control.action}
						active={active}
						style={control.style}
						onClick={() => {
							props.updateEditorState(RichUtils.toggleBlockType(editorState, control.action));
						}}
					>
						{t(control.name)}
					</Button>
				)})}
			<div style={{ height: '10px' }} />
			{ showInlineControls &&
			<Label>{t('controls/text/format/inline/label')}</Label>}
			{ showInlineControls &&
			inlineControlElements}
		</Container>
	)
}

TextControls.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	editorState: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	changesHandler: PropTypes.func,
	updateEditorState: PropTypes.func,
}

export default translate('translations')(TextControls)
